/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 获取供应商邀约规则 的 **请求配置**
 *
 * @分类 旧接口文档/前置仓邀约池
 * @请求头 `POST /erp/PreStorageInviteRule/getInvitationRule`
 */
const postGetInvitationRuleRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PreStorageInviteRule/getInvitationRule",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetInvitationRule",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取供应商邀约规则 的 **请求函数**
 *
 * @分类 旧接口文档/前置仓邀约池
 * @请求头 `POST /erp/PreStorageInviteRule/getInvitationRule`
 */
export const postGetInvitationRule = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetInvitationRuleRequestConfig, requestData),
    ...args
  );
};
postGetInvitationRule.requestConfig = postGetInvitationRuleRequestConfig;
/**
 * 接口 保存供应商邀约规则 的 **请求配置**
 *
 * @分类 旧接口文档/前置仓邀约池
 * @请求头 `POST /erp/PreStorageInviteRule/saveInvitationRule`
 */
const postSaveInvitationRuleRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/PreStorageInviteRule/saveInvitationRule",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveInvitationRule",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存供应商邀约规则 的 **请求函数**
 *
 * @分类 旧接口文档/前置仓邀约池
 * @请求头 `POST /erp/PreStorageInviteRule/saveInvitationRule`
 */
export const postSaveInvitationRule = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSaveInvitationRuleRequestConfig, requestData),
    ...args
  );
};
postSaveInvitationRule.requestConfig = postSaveInvitationRuleRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/preStorageInviteRule.js